import { getCreators } from '@/api/community';
import search from '@/api/search';

const DEFAULT_STATE = {
  loading: false,
  content: [],
  pagination: {
    page: 0,
    limit: 20,
  },
  hasMore: true,
};

export default {
  namespaced: true,
  state: { ...JSON.parse(JSON.stringify(DEFAULT_STATE)) },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setContent(state, payload) {
      state.content = state.content.concat(payload);
      if (payload.length < state.pagination.limit) {
        state.hasMore = false;
        state.pagination.page = 0;
      } else {
        state.pagination.page += 1;
      }
    },
    resetState(state) {
      const resetState = { ...JSON.parse(JSON.stringify(DEFAULT_STATE)) };
      Object.keys(state)
        .forEach((key) => {
          state[key] = resetState[key];
        });
    },
  },
  actions: {
    async getCreators({ commit, dispatch, getters }) {
      try {
        commit('setLoading', true);
        const { pagination: { page, limit } } = getters;
        const { data } = await getCreators(page, limit);
        commit('setContent', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setLoading', false);
      }
    },
    async searchCreators({ commit, dispatch, getters }, { query }) {
      try {
        commit('setLoading', true);
        const { pagination: { page, limit } } = getters;
        const { data } = await search.creators(query, page, limit);
        commit('setContent', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    loading: state => state.loading && !state.content.length,
    loadMoreLoading: state => state.loading && !!state.content.length,
    content: state => state.content || [],
    pagination: state => state.pagination,
    hasMore: state => state.hasMore && !!state.content.length,
  },
};
